import { Button, Checkbox, CircularProgress, FormControlLabel, TextField, styled } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { getBlob, readXml } from '../../features/manageSSO/manageSSOService';
import { openPopup } from '../../stateManagement/actions/popupActions';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

function SSOForm(props: any) {
    const { handleChange, options, file, setFile, values } = props;
    const [fileUploadLoading, setFileUploadLoading] = useState<boolean>(false);

    const handleFileUpload = async (e: any) => {
        const file = e.target.files[0];
        let newVals = { ...values };
        try {
            const formData = new FormData();
            formData.append("file", file);
            setFileUploadLoading(true);
            const blobKey = await getBlob(formData);
            newVals[e.target.id] = blobKey;
            setFile(file)
            const tmppath = URL.createObjectURL(file);
            const xmlDoc: Document | null = readXml(tmppath);
            let entityId;

            if (xmlDoc && xmlDoc.getElementsByTagName("EntityDescriptor").length > 0) {
                entityId = xmlDoc.getElementsByTagName("EntityDescriptor")[0].getAttribute("entityID");
            } else if (xmlDoc && xmlDoc.getElementsByTagName("md:EntityDescriptor").length > 0) {
                entityId = xmlDoc.getElementsByTagName("md:EntityDescriptor")[0].getAttribute("entityID");
            } else {
                openPopup("Error", "Invalid xml");
                return;
            }
            var type = (xmlDoc.getElementsByTagName("md:SPSSODescriptor").length > 0) ? "SP" : "IDP";
            newVals["registrationId"] = entityId;
            newVals["extras"] = { "type": type };

        } catch (error) {
            console.error("error");
            openPopup("Error", "Error in file upload");
        } finally {
            setFileUploadLoading(false);
            return newVals;
        }

    }


    const onChange = async (e: any, type: string) => {
        let val = null;
        switch (type) {
            case 'input': val = e.target.value;
                handleChange({ ...values, [e.target.id]: val })
                break;
            case 'file': val = await handleFileUpload(e);
                handleChange(val);
                break;
            case 'checkbox': val = e.target.checked;
                handleChange({ ...values, [e.target.id]: val })
                break;
        }
    }

    return (
        <div className='sso-form-wrapper'>
            {
                options.map((option: any) => {
                    return <>
                        {
                            option.type === "input" && <TextField
                                id={option.id}
                                key={option.id}
                                value={values?.[option.id] ?? ""}
                                hidden={option.hidden}
                                disabled={option.disable}
                                label={option.label}
                                variant="outlined"
                                size='small'
                                data-type={option.type}
                                onChange={(e) => onChange(e, option.type)}
                            />
                        }
                        {
                            option.type === "file" &&

                            <div className='sso-form-file-upload-container' key={option.id}>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    {
                                        (!file && values[option.id] && values[option.id] !== "") &&
                                        <div>

                                            <p style={{ fontWeight: 'bold' }}>Uploaded Federation XML</p>
                                            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                                                <span className='upload-file-text'>
                                                    {
                                                        values[option.id]
                                                    }
                                                </span>

                                                <Button variant='outlined' onClick={() => { handleChange({ ...values, [option.id]: '' }) }}>Reset</Button>
                                            </div>
                                        </div>
                                    }
                                </div>

                                <div className='sso-form-file-upload-wrapper'>
                                    <Button
                                        component={"label"}
                                        role={undefined}
                                        variant="contained"
                                        hidden={option.hidden}
                                        startIcon={<CloudUploadIcon />
                                        }
                                    >
                                        {option.label}
                                        <VisuallyHiddenInput
                                            id={option.id}
                                            type="file"
                                            accept={option.formats}
                                            data-type={option.type}
                                            onChange={(e) => onChange(e, option.type)}
                                            hidden={option.hidden}
                                        />
                                    </Button>
                                    {

                                        fileUploadLoading ? <CircularProgress />
                                            : <span>{file?.name ?? ""}</span>
                                    }

                                </div>
                            </div>
                        }
                        {
                            option.type === "checkbox" && <FormControlLabel
                                key={option.id}
                                label={option.label}
                                checked={values?.[option.id] ?? false}
                                onChange={(e) => onChange(e, option.type)}
                                control={<Checkbox id={option.id} />}
                                hidden={option.hidden}
                            />
                        }
                    </>
                })
            }

        </div>
    )
}

export default SSOForm;